import { defineComponent as _defineComponent } from 'vue'
import { sanitizedLink as link } from '@@/bits/autolinker'
import { tailwindSurfaceFontClass } from '@@/bits/font'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceTitleDescription',
  props: {
  fontId: {
    required: true,
    type: Number,
  },
  text: {
    required: true,
    type: String,
  },
  colorScheme: {
    type: String,
    default: 'light',
  },
},
  setup(__props) {

const props = __props;



const fontClass = computed(() => tailwindSurfaceFontClass(props.fontId))
const hyperlinkedText = ref<string>(props.text)

watch(
  () => props.text,
  async (text) => (hyperlinkedText.value = await link(text, { className: 'break-all' })),
  { immediate: true },
)

return { __sfc: true,props, fontClass, hyperlinkedText }
}

})